// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"c0143388","453":"be0cf052","512":"73c3517a"}[chunkId] + ".chunk.js";
};